<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 22.2071C17.6331 22.2071 22.1998 17.6404 22.1998 12.0071C22.1998 6.37382 17.6331 1.80713 11.9998 1.80713C6.3665 1.80713 1.7998 6.37382 1.7998 12.0071C1.7998 17.6404 6.3665 22.2071 11.9998 22.2071Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.65303 19.986L6.5597 15.4073H7.5389C7.74569 15.408 7.94985 15.3609 8.13544 15.2697C8.32102 15.1785 8.48302 15.0456 8.60877 14.8814C8.7383 14.721 8.82801 14.5323 8.87056 14.3306C8.91311 14.1288 8.90728 13.9199 8.85357 13.7209L8.17357 11.0009C8.10231 10.706 7.93387 10.4437 7.69539 10.2562C7.45691 10.0687 7.16226 9.96694 6.8589 9.96729H2.02637"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.1606 5.88721H16.4614C16.158 5.88686 15.8634 5.98863 15.6249 6.17613C15.3864 6.36363 15.218 6.62593 15.1467 6.92081L14.4667 9.64081C14.4142 9.84054 14.4099 10.0499 14.454 10.2516C14.4981 10.4534 14.5895 10.6418 14.7206 10.8013C14.8463 10.9655 15.0083 11.0984 15.1939 11.1896C15.3795 11.2808 15.5836 11.3279 15.7904 11.3272H17.223L17.9302 15.6339C17.9832 15.9479 18.1448 16.2333 18.3867 16.4404C18.6286 16.6475 18.9355 16.7632 19.2539 16.7672H21.0672"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
